import { useEffect, useState } from "react";
import { Container, Tab, Tabs, TabContent } from "react-bootstrap";
import { MainTabSection } from "./manageDashboard";
import EditProfile from "../../components/common/nonprofitEditProfile";
import ShowOffYourReviews from "../../components/common/showOffYourReviews";
import MediaGallery from "../../components/common/nonprofitMediaGallery";
import InviteReviewsTabBox from "../../components/common/inviteReviewsTab";
import ProfileTabView from "../../components/common/profileTabView";
import ManageMyNonprofitStats from "../../components/common/profileTabView/manageMyNonprofitStats";

import NonProfitDonations from "../../components/common/nonprofitDonations";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MESSAGE } from "../../utils/message";
import { useSelector } from "react-redux";
import MetaComponent from "../../components/common/metaComponent";
import { SectionTitle, Title } from "../../components/common/showOffYourReviews/showOffYourReviewsStyle";
const ManageDashboard = () => {
  const params = useParams()
  const [key, setKey] = useState<string>('');
  const { pathname } = useLocation();
  const navigate = useNavigate()
  const nonprofitStats = useSelector((state: any) => state?.nonprofitStats?.data?.results)

  useEffect(() => {
    if (pathname) {
      setKey(pathname)
    } else {
      setKey(`/dashboard/stats/${params.id}`)
    }
  }
    , [pathname])

  return (
    <>
      <MetaComponent
        keywords=""
        description=""
        ogTitle=""
        ogDescription=""
        ogUrl=""
        ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
      />
      <MainTabSection>
        <Container className="cont-w">
          <Tabs
            activeKey={key}
            onSelect={(eventKey: any) => {
              if (eventKey.includes("/dashboard/profile") && nonprofitStats) {
                navigate(`${eventKey}?slug=${nonprofitStats?.slug}`)
              } else {
                navigate(eventKey)
              }
            }}
            mountOnEnter={true}
            className="responsive-tabs" fill>
            <Tab eventKey={`/dashboard/edit/${params.id}`} title={MESSAGE.editProfile}>
              <TabContent>
                {" "}
                <EditProfile />{" "}
              </TabContent>
            </Tab>
            <Tab eventKey={`/dashboard/donations/${params.id}`} title={MESSAGE.Donations}>
              <TabContent>
                <NonProfitDonations />{" "}
              </TabContent>
            </Tab>
            <Tab eventKey={`/dashboard/gallery/${params.id}`} title={MESSAGE.mediaGallery}>
              <TabContent>
                <MediaGallery setKey={setKey} />
              </TabContent>
            </Tab>
            <Tab eventKey={`/dashboard/stats/${params.id}`} title={MESSAGE.nonprofitStats}>
              <TabContent>
                <ManageMyNonprofitStats setKey={setKey} />
              </TabContent>
            </Tab>
            <Tab eventKey={`/dashboard/review/${params.id}`} title={MESSAGE.showOffYourReviews}>
              <TabContent>
                <ShowOffYourReviews />
              </TabContent>
            </Tab>
            <Tab eventKey={`/dashboard/invite/${params.id}`} title={MESSAGE.inviteReviews}>
              <TabContent>
                {" "}
                <InviteReviewsTabBox />{" "}
              </TabContent>
            </Tab>
            <Tab eventKey={`/dashboard/toprated/${params.id}`} title={MESSAGE.topRatedStatus}>
              <TabContent> <SectionTitle>
                <Title>Top-Rated Status</Title>
              </SectionTitle></TabContent>
            </Tab>
            <Tab eventKey={`/dashboard/profile/${params.id}`} title={MESSAGE.profile}>
              <TabContent>
                <ProfileTabView />
              </TabContent>
            </Tab>
          </Tabs>
        </Container>
      </MainTabSection>
    </>

  );
};

export default ManageDashboard;
